import Model, { attr } from '@ember-data/model';

export default class SentinelUserModel extends Model {
  @attr
  declare email: string;

  @attr
  declare hotelIds: string[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'sentinel/user': SentinelUserModel;
  }
}
